
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"24","width":"24","id":"Cursor-Select-2--Streamline-Streamline--3.0.svg"}, attrs),
              ...rest,
            },
            children.concat([_c('desc',[_v('Cursor Select 2 Streamline Icon: https://streamlinehq.com')]),_c('defs'),_c('title',[_v('cursor-select-2')]),_c('path',{attrs:{"d":"M0.751 3.747a3 3 0 0 1 3 -3","fill":"none","stroke":"#3b82f6","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M3.751 20.247a3 3 0 0 1 -3 -3","fill":"none","stroke":"#3b82f6","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M17.251 0.747a3 3 0 0 1 3 3","fill":"none","stroke":"#3b82f6","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m20.251 12.747 0 -4.5","fill":"none","stroke":"#3b82f6","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m0.751 12.747 0 -4.5","fill":"none","stroke":"#3b82f6","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m8.251 0.747 4.5 0","fill":"none","stroke":"#3b82f6","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m8.251 20.247 4.5 0","fill":"none","stroke":"#3b82f6","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m14.765 14.762 3.182 8.485 1.591 -3.712 3.713 -1.591 -8.486 -3.182z","fill":"none","stroke":"#3b82f6","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    